module.exports = __webpack_public_path__ + "img/customer_back.2a33d298.jpg";